import React from "react";

/* ══════════════════════════════════════════════════════════════
   LUMINEX LOGO — BPMN decision diamond with crosshair + orange core
   Matches the glyph used in `PlatformLuminex` hero and the
   `CapexaraCognitiveSubstrate` card so the brand reads the same
   everywhere the product appears.
   ══════════════════════════════════════════════════════════════ */

export function LuminexIcon({ size = 56, className = "" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 56 56"
      width={size}
      height={size}
      aria-hidden="true"
      className={`vd-mark ${className}`}
    >
      {/* Rotated square (decision diamond) */}
      <rect x="12" y="12" width="32" height="32" rx="3" className="vd-mark-shape" fill="none" strokeWidth="2" transform="rotate(45 28 28)" />
      {/* Crosshair tick lines */}
      <line x1="28" y1="0" x2="28" y2="10" className="vd-mark-tick" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="28" y1="46" x2="28" y2="56" className="vd-mark-tick" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="0" y1="28" x2="10" y2="28" className="vd-mark-tick" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="46" y1="28" x2="56" y2="28" className="vd-mark-tick" strokeWidth="1.5" strokeLinecap="round" />
      {/* Orange core */}
      <circle cx="28" cy="28" r="4" fill="#F26B1F" />
    </svg>
  );
}

export default LuminexIcon;
